import React from 'react';
require('./checkbox.scss');

export const CheckboxComponent = ({ checked, labelText, onChange }) => {
  return (
    <div className="l-checkbox__container">
      <input
        type="checkbox"
        className="l-checkbox"
        checked={checked}
        onChange={onChange}
        id="custom-checkbox"
      />
      <label htmlFor="custom-checkbox" className="l-checkbox__text">
        {labelText}
      </label>
    </div>
  );
};
